module.exports = __webpack_public_path__ + "static/media/message-view-active-icon.89dd0c9c.svg";